import { createClient } from '@supabase/supabase-js';

export const supabaseUrl = 'https://lbazotqhqiozgdpforfl.supabase.co';
export const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxiYXpvdHFocWlvemdkcGZvcmZsIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NjU0OTM0NTMsImV4cCI6MjA4MTA2OTQ1M30.nMLQ19z3NhhEGQCSMPm_P4A9P6wY64ZeFPCkGGMtuY4';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
